import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators'
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private token: any = '';
  private userId: string = '';
  serverUrl: string;
  userType: string = '';
  private readonly appointmentZoomDataKey = 'appointmentZoomData';
  private readonly appointmentDataKey = 'appointmentData';

  public currentZoomData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentAppointment: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private hideDashboard = new BehaviorSubject<boolean>(false);
  hideData$: Observable<boolean> = this.hideDashboard.asObservable();
  constructor(
    private http: HttpClient, 
    private router: Router
  ) {
    //localhost
if(window.location.hostname.indexOf("localhost") > -1) {
 this.serverUrl = "http://localhost:8080"
 //this.serverUrl = "http://44.197.126.217/"

} else {  //server
 this.serverUrl = window.location.origin
//this.serverUrl = "http://44.197.126.217:8080"
}
  // Initialize data from localStorage on service initialization
  const storedZoomData = localStorage.getItem(this.appointmentZoomDataKey);
  const storedAppointmentData = localStorage.getItem(this.appointmentDataKey);
  if (storedZoomData) {
    this.currentZoomData.next(JSON.parse(storedZoomData));
  }
  if (storedAppointmentData) {
    this.currentAppointment.next(JSON.parse(storedAppointmentData));
  }
   }

    // Error handling
  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = 'Opps Error';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = error.error.message;
    }
    // console.log(errorMessage);
    return throwError(errorMessage);
  }

  //function to get token from localStorage
  private getToken(): string {
    if (!this.token) {
      this.token =  this.getKeyFromStorage('accessToken')
    }
    return this.token
  }

//function to get key from storages
private getKeyFromStorage(key : any): any {
  if(localStorage.getItem(key)) {
    return localStorage.getItem(key)
  } else if(sessionStorage.getItem(key)) {
    return sessionStorage.getItem(key)
  }
  return "";
}

//function to get key from storages
private removeKeyFromStorage(key : any): any {
  if(localStorage.getItem(key)) {
    localStorage.removeItem(key)
  }
  if(sessionStorage.getItem(key)) {
     sessionStorage.removeItem(key)
  }
}
isLoggedIn() {
  let usertype = localStorage.getItem("endUserType");
  let userid = localStorage.getItem("endUserId")

  if (!usertype || !userid) {
    return false
  } else
    return usertype

}
//function to get user id from localStorage
  public getUser(): string {
    if (!this.userId) {
      this.userId = this.getKeyFromStorage('userId')
    }
    return this.userId
  }
//function to save token and user id
private saveToken(token: string, userId: string, userType: string, username: string, userDetails: string, req:any): void {
  this.token = token
  this.userId = userId
  this.userType = userType
  if(typeof(userDetails) != 'string') {
    userDetails = JSON.stringify(userDetails)
  }
  localStorage.setItem('userId', userId)
  localStorage.setItem('userType', userType)
  localStorage.setItem('username', username)
  localStorage.setItem('userDetails', userDetails)
  let stayLoggedIn = localStorage.getItem("stayLoggedIn") || sessionStorage.getItem("stayLoggedIn")
  if(!stayLoggedIn) {
    localStorage.setItem("stayLoggedIn", "local")
  }
}
  //function to make request from frontend
  private request(method: 'post' | 'get' | 'put' | 'delete' | 'patch', type: string, data?: any): Observable<any> {
    let base
    this.token= localStorage.getItem("accessToken")
    if (method === 'post') {
      base = this.http.post(this.serverUrl + `/api/${type}`, data , { headers: { Authorization: `Bearer ${this.token}` }})
    } else if (method === 'get') {
      base = this.http.get(this.serverUrl + `/api/${type}`, { headers: {Authorization: `Bearer ${this.token}` }, params: data })
    } else if (method === 'put') {
      base = this.http.put(this.serverUrl + `/api/${type}`,data, { headers: { Authorization: `Bearer ${this.token}` }})
    } else if (method === 'patch') {
      base = this.http.patch(this.serverUrl + `/api/${type}`,data, { headers: { Authorization: `Bearer ${this.token}` }})
    } else if (method === 'delete') {
      base = this.http.delete(this.serverUrl + `/api/${type}`, { headers: { Authorization: `Bearer ${this.token}` }})
    } else {
      throw new Error(`Unsupported HTTP method: ${method}`)
    }

    const request = base.pipe(
      map((response: any) => {
        if (response.data && response.data.token) {
          //check if user type is same
          if( data.userType === response.data.userType ) {
            const { token, userId, userType, username, userDetails } = response.data
            this.saveToken(token, userId, userType, username, userDetails, data)
            return response
          } else {
            return { status: "error", data: { message: "Please check your credentials" }}
          }
        } else {
          return response
        }
      })
    )
    return request
  }

  //function to make request to server to logout user
  public logout(): void {
    this.token = localStorage.getItem("accessToken")
    const userId = localStorage.getItem("endUserId")
    const userType = localStorage.getItem("endUserType")
    this.removeKeyFromStorage('endUserId')
    this.removeKeyFromStorage('endUserType')
    this.removeKeyFromStorage('endUserEmail')
    this.removeKeyFromStorage('endUserFirstName')
    this.removeKeyFromStorage('endUserLastName')
    this.removeKeyFromStorage('urlFromLogin')
    this.removeKeyFromStorage('endUserProfileName')
    this.removeKeyFromStorage('accessToken')
    this.removeKeyFromStorage('speciality')
    this.removeKeyFromStorage('status')
    this.removeKeyFromStorage('plaidLinkToken')
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.http.post(this.serverUrl + '/api/user/logout', null, { headers: { Authorization: `Bearer ${this.token}` } })
    .subscribe((res) => {
      this.redirectToSignIn(userType, userId)

    }, err=>{
      this.redirectToSignIn(userType, userId)
    })
  }

  redirectToSignIn(userType?, userId?) {
    if (environment.features?.specialtyIntakeEnabled) {
      // Only VC/PCV users use SSO — redirect through Microsoft logout to clear Entra session
      // Admin and specialist use email/password login — no SSO logout needed
      if (userType === 'vc' || userType === 'pcv') {
        const logoutUrl = userId
          ? `${this.serverUrl}/api/auth/saml/logout?userId=${userId}`
          : `${this.serverUrl}/api/auth/saml/logout`;
        window.location.href = logoutUrl;
      } else if (userType === 'specialist') {
        window.location.href = '/auth/specialist-signin';
      } else if (userType === 'admin') {
        window.location.href = '/auth/admin-signin';
      } else {
        window.location.href = '/';
      }
    } else {
      // Legacy behavior: redirect to landing page
      window.location.href = environment.landingUrl;
    }
  }

  //function to make request to server
  public apiRequest(method : any, apiUrl : any, req_vars: any): Observable<any> {
   let token = localStorage.getItem('accessToken');
   // Only add accessToken to request body for POST/PUT/PATCH methods
   // GET and DELETE should not have accessToken in params/body (it's in headers already)
   if(token !== undefined && token != "" && method !== 'get' && method !== 'delete'){
    req_vars.accessToken = token;
   }
   let response = this.request(method, apiUrl, req_vars);
   return response;
  }

   // add card detail
 public   addnewCardCustomerId(data: any): Observable<any> {
    const url = `${this.serverUrl}/api/pcv/addnewCardCustomerId`;
    return this.http.post(url, data).pipe(
      catchError(this.errorMgmt)
    );
  }

    // get card detail
    getCustomerCards(data: any): Observable<any> {
      const url = `${this.serverUrl}/api/pcv/getCustomerCards`;
      return this.http.post(url, data).pipe(
        catchError(this.errorMgmt)
      );
    }
    updateZoomData(data: any): void {
      this.currentZoomData.next(data);
      // Store updated data in localStorage
      localStorage.setItem(this.appointmentZoomDataKey, JSON.stringify(data));
    }
    updateAppointment(data: any): void {
      this.currentAppointment.next(data);
      // Store updated data in localStorage
      localStorage.setItem(this.appointmentDataKey, JSON.stringify(data));
    }
    setDashboardHide(data) {
      this.hideDashboard.next(data);
    }
    
    getSignedUrl(filename: string, folder: string): Observable<any> {
      const url = `${this.serverUrl}/api/user/getSignedUrl?filename=${filename}&filePath=${folder}`;
      return this.http.get(url, { 
        headers: { Authorization: `Bearer ${this.getToken()}` } 
      }).pipe(
        catchError(this.errorMgmt)
      );
    }

    getCaseAttachmentUrl(
      caseId: string,
      source: 'files' | 'additionalUploadsBySpecialist' | 'additionalUploadsByAdmin',
      index: number,
      mode: 'view' | 'download'
    ): Observable<any> {
      return this.apiRequest('post', `pcv/cases/${caseId}/attachment-url`, {
        source,
        index,
        mode
      });
    }
  
}
